const options: any = {
  chart: {
    id: "vuechart-example-3",
    toolbar: { show: false },
  },
  // labels: [],
  colors: ['#F3B399'],
  legend: {
    position: 'bottom',
  },
  plotOptions: {
    pie: {
      donut: {
        size: '75%',
      }
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    curve: 'smooth',
  },
  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.9,
      stops: [0, 90, 100]
    }
  },
  // xaxis: {
  //   type: 'category',
  //   labels: {
  //     show: true
  //   },
  //   categories: [
  //     "01 Jan",
  //     "02 Jan",
  //     "03 Jan",
  //     "04 Jan",
  //     "05 Jan",
  //     "06 Jan",
  //     "07 Jan"
  //   ]
  // }
};

const series: any = [{
  data: [[0, 55], [10, 100], [20, 80], [40, 120], [60, 100], [65, 120], [70, 100],
  [78, 80], [85, 100], [95, 120], [120, 60]]
}];

const type = 'area';

const thinBar = { type, options, series };

export default thinBar;
